var xP = function (params, parent) {
  // TODO: Добавить третий параметр в котором можно передавать data-xp.
  if (!params) {
    params = '[data-xp], [data-expromptum]';
    for (var i = 0, ii = xP_controls_registered.length; i < ii; i++) {
      params += ','
      + xP.controls[xP_controls_registered[i]]
        .prototype.element_selector;
    }
  }

  if (
    // CSS selector.
  $.type(params) === 'string'
    // DOM element.
  || params && (
  params.nodeType
    // DOM collection.
  || params[0] && params[0].nodeType
  )
  ) {
    params = $(
      params,
      parent
        ? (
        parent instanceof xP.controls._item
          ? parent.$container
          : parent
      )
        : null
    );
  }

  if (params instanceof jQuery) {
    return xP.controls.init(params);
  } else if (params instanceof Object && parent) {
    return xP.controls.create(params, parent);
    // Create by params.
  } else {
    xP.debug('', 'error', 'unknown params', params);

    return new xP.list();
  }
};

xP.register = function (params) {
  var prototype = params.prototype || {},
    expromptum = prototype.init
      ? function () {
      this._ = {};
      prototype.init.apply(this, arguments);
    }
      : null,
    base = params.base;

  // For console.
  prototype.toString = function () {
    return params.name
  };

  if (base) {
    if (!expromptum) {
      expromptum = base.prototype.init
        ? function () {
        this._ = {};
        base.prototype.init.apply(this, arguments);
      }
        : function () {
        this._ = {};
      };
    }

    var f = function () {
    };

    f.prototype = base.prototype;

    expromptum.prototype = new f();

    expromptum.prototype.constructor = expromptum;

    expromptum.base = base.prototype;
  } else if (!expromptum) {
    expromptum = function () {
    };
  }

  $.extend(expromptum.prototype, prototype);

  return expromptum;
};

xP.list = function (arr) {
  var result = $.type(arr) === 'array' ? arr : (arr ? [arr] : []);

  result.append = function (obj) {
    if (!obj) {
      return this;
    }

    if ($.type(obj) === 'array') {
      for (var i = 0, ii = obj.length; i < ii; i++) {
        this.append(obj[i]);
      }

      return this;
    }

    if (this.index(obj) === -1) {
      this.push(obj);
    }

    return this;
  };

  result.remove = function (obj) {
    if ($.type(obj) === 'array') {
      var i = obj.length;

      while (i--) {
        this.remove(obj[i]);
      }

      return this;
    }

    var i = this.index(obj);

    if (i > -1) {
      this.splice(i, 1);
    }

    return this;
  };

  result.filter = function (handler) {
    return this.each(handler, true);
  };

  result.each = function (handler, _filter) {
    var i = 0, ii = this.length, current, result;

    while (i < ii) {
      current = this[i];

      result = handler.apply(current, [i]);

      if (result === false) {
        if (_filter) {
          this.splice(i, 1);
        } else {
          break;
        }
      }

      if (this[i] === current) {
        i++;
      } else {
        ii = this.length;
      }
    }

    return this;
  };

  result.first = function (handler) {
    return this.eq(0, handler);
  };

  result.last = function (handler) {
    return this.eq(this.length - 1, handler);
  };

  result.eq = function (i, handler) {
    if (!this.length) {
      return null;
    }

    if (handler) {
      handler.apply(this[i % this.length]);
    }

    return this[i % this.length];
  };

  result.index = function (obj) {
    var i = this.length;

    while (i--) {
      if (obj === this[i]) {
        return i;
      }
    }

    return -1;
  };

  return result;
};

xP.debug = function () {
  if (location.href.indexOf('xP=' + arguments[0]) > 0) {
    console.log.apply(this, Array.prototype.slice.call(arguments, 1));

    return true;
  } else {
    return false;
  }
};

xP.after = function (handler, i) {
  if (i) {
    return setTimeout(function () {
      xP.after(handler, --i);
    }, 0);
  } else {
    return setTimeout(function () {
      handler()
    }, 0);
  }
};

xP.taint_regexp = function (value) {
  return value.replace(xP.taint_regexp_pattern, '\\');
};

xP.taint_regexp_pattern = /(?=[\\\^\$\.\[\]\|\(\)\?\*\+\{\}])/g;

xP.taint_css = function (value) {
  return value.replace(xP.taint_css_pattern, '\\');
};

xP.taint_css_pattern = /(?=[\\\^\$\.\[\]\|\(\)\?\*\+\{\}\:\<\>\@\/\~\&\=])/g;

/* Locale */
xP.locale = require('./locale');
xP.locale.init();

/* Base */
xP.base = xP.register({
  name: 'xP.base', prototype: {

    init: function (params) {
      this._.on_destroy = new xP.list();
      this._.on_change = new xP.list();

      $.extend(this, params);
    },

    destroy: function (handler, remove) {
      if (!arguments.length) {
        clearTimeout(this._.change_inquiry);

        var that = this;

        this._.on_destroy.each(function () {
          this.call(that);
        });
      } else {
        if (remove) {
          this._.on_destroy.remove(handler);
        } else {
          this._.on_destroy.append(handler);
        }
      }

      return this;
    },

    change: function (handler, remove) {
      if (!arguments.length) {
        if (!this._.change_inquiry) {
          clearTimeout(this._.change_inquiry);

          var that = this;

          that._.change_inquiry = xP.after(function () {
            that._.change_inquiry = null;

            that._.on_change.each(function () {
              this.call(that);
            });
          });
        }
      } else {
        if (remove) {
          this._.on_change.remove(handler);
        } else {
          this._.on_change.append(handler);
        }
      }

      return this;
    },

    param: function (name, value) {
      if (arguments.length === 2) {
        this[name] = value;
      }

      return this[name];
    },

    _param: function (name, value) {
      if (arguments.length === 2) {
        this._[name] = value;
      }

      return this._[name];
    }
  }
});

/* Controls */

var xP_controls_registered = [];

xP.controls = {
  register: function (params) {
    var name = params.name;

    if (!params.prototype) {
      params.prototype = {};
    }

    params.prototype.type = name;

    this[params.name] = xP.register(
      $.extend(
        params,
        {
          name: 'expromptum.controls.' + name,
          base: $.type(params.base) === 'string'
            ? this[params.base]
            : params.base
        }
      )
    );

    if (params.prototype && params.prototype.element_selector) {
      xP_controls_registered.push(name);
    }
  },

  init: function ($elements) {
    var result = new xP.list(), that = this;

    $elements.each(function () {
      var $element = $(this), control = that.link($element);

      if (!control) {
        var params = $element.data('xp')
          || $element.data('expromptum');

        if ($.type(params) === 'string') {
          if (!params.match(/^^\s*\{/)) {
            params = '{' + params + '}';
          }

          params = eval(
            '(function(){return '
            + params
              .replace(/([\{,])\s*do\s*:/g, '$1\'do\':')
            + '})()'
          );
        }

        $element
          .removeAttr('data-xp')
          .removeAttr('data-expromptum');

        if (!params) {
          params = {};
        }

        if (!params.type) {
          var i = xP_controls_registered.length;

          while (i--) {
            if (
              $element.is(
                xP.controls[xP_controls_registered[i]]
                  .prototype.element_selector
              )
            ) {
              params.type = xP_controls_registered[i];

              break;
            }
          }
        }

        if (
          xP.controls[params.type]
          && xP.controls[params.type].base
        ) {
          params.$element = $element;

          control = new xP.controls[params.type](params);
        }
      }

      if (control) {
        result.append(control);
      }
    });

    return result;
  },

  link: function ($element, control) {
    if (control) {
      $element.data('expromptum.control', control);

      $element[0].expromptum = control;
    } else {
      return $element.data('expromptum.control');
    }
  }
};

/* Dependencies */

var xP_dependencies_registered = [];

xP.dependencies = {
  _controls: {},
  _functions: [],

  register: function (params) {
    var name = params.name;

    if (!params.prototype) {
      params.prototype = {};
    }

    params.prototype.type = name;

    this[params.name] = xP.register(
      $.extend(
        params,
        {
          name: 'expromptum.dependencies.' + name,
          base: $.type(params.base) === 'string'
            ? this[params.base]
            : params.base
        }
      )
    );

    xP_dependencies_registered.push(name);
  },

  init: function (params, control) {
    var that = this;

    xP.after(function () {
      if (!control && params instanceof xP.controls._item) {
        control = params;
      }

      var i = 0, ii = xP_dependencies_registered.length, param;

      for (; i < ii; i++) {
        param = params[xP_dependencies_registered[i]];

        if (param && !(param instanceof xP.dependencies._item)) {
          if ($.type(param) === 'array') {
            for (var j = 0, jj = param.length; j < jj; j++) {
              new that[xP_dependencies_registered[i]](
                param[j], control
              );
            }
          } else {
            new that[xP_dependencies_registered[i]](
              param, control
            );
          }
        }
      }
    });
  }
};

module.exports = xP;



/*****************
 ** WEBPACK FOOTER
 ** ./lib/xP.js
 ** module id = 1
 ** module chunks = 0
 **/